import React from "react";
import {
  Card, CardContent
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../../base/form/form_fields.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import { AdminUserModel } from "../../../../../../models/users/admin/user_model.js";
import { AdminUserPersonalInfoModel } from "../../../../../../models/users/admin/user_personal_info_model.js"


const styles = theme => ({
});

const PersonalInfoCard = (props) => {


  const { classes, errorData } = props;
  const { onItemChanged } = props;

  const user = Object.assign({}, props.user) || {};
  user.personalInfo = itemWithKeys(user.personalInfo, AdminUserPersonalInfoModel.formFieldsWhitelist(user.personalInfo))

  const formFields = AdminUserModel.formFields({item: user});

  const personalInfoFields = ["personalInfo", "password"];

  return (
    <Card className = { classes.card } >
      <CardContent >
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.personal_info")}
        </div>
        <FormFields formFields = { formFields.filter(field => personalInfoFields.includes(field.name)) }
                    item = { itemWithKeys(user, personalInfoFields) }
                    errorData = { errorData }
                    onItemChange = { onItemChanged }
                    defaultWeight = { 6 } />
      </CardContent>
    </Card>
  );
}

PersonalInfoCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(PersonalInfoCard);
